export const ACCESS_TOKEN_KEY = "token";
export const REFRESH_TOKEN_KEY = "refreshToken";

export function getAccessTokenFromStorage() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessTokenToStorage(token: string) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function cleanAccessTokenFromStorage() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function getRefreshTokenFromStorage() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setRefreshTokenToStorage(token: string) {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
}

export function cleanRefreshTokenFromStorage() {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function cleanAllTokensFromStorage() {
  cleanAccessTokenFromStorage();
  cleanRefreshTokenFromStorage();
}
